var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prefix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/call"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3077 15.7751C18.3077 16.0751 18.241 16.3834 18.0993 16.6834C17.9577 16.9834 17.7744 17.2667 17.5327 17.5334C17.1244 17.9834 16.6743 18.3084 16.166 18.5167C15.666 18.7251 15.1244 18.8334 14.541 18.8334C13.691 18.8334 12.7827 18.6334 11.8243 18.2251C10.866 17.8167 9.90768 17.2667 8.95768 16.5751C7.99935 15.8751 7.09102 15.1001 6.22435 14.2417C5.36602 13.3751 4.59102 12.4667 3.89935 11.5167C3.21602 10.5667 2.66602 9.61675 2.26602 8.67508C1.86602 7.72508 1.66602 6.81675 1.66602 5.95008C1.66602 5.38341 1.76602 4.84175 1.96602 4.34175C2.16602 3.83341 2.48268 3.36675 2.92435 2.95008C3.45768 2.42508 4.04102 2.16675 4.65768 2.16675C4.89102 2.16675 5.12435 2.21675 5.33268 2.31675C5.54935 2.41675 5.74102 2.56675 5.89102 2.78341L7.82435 5.50842C7.97435 5.71675 8.08268 5.90841 8.15768 6.09175C8.23268 6.26675 8.27435 6.44175 8.27435 6.60008C8.27435 6.80008 8.21602 7.00008 8.09935 7.19175C7.99102 7.38341 7.83268 7.58341 7.63268 7.78341L6.99935 8.44175C6.90768 8.53341 6.86602 8.64175 6.86602 8.77508C6.86602 8.84175 6.87435 8.90008 6.89102 8.96675C6.91602 9.03341 6.94102 9.08341 6.95768 9.13341C7.10768 9.40841 7.36602 9.76675 7.73268 10.2001C8.10768 10.6334 8.50768 11.0751 8.94102 11.5167C9.39102 11.9584 9.82435 12.3667 10.266 12.7417C10.6993 13.1084 11.0577 13.3584 11.341 13.5084C11.3827 13.5251 11.4327 13.5501 11.491 13.5751C11.5577 13.6001 11.6243 13.6084 11.6993 13.6084C11.841 13.6084 11.9493 13.5584 12.041 13.4667L12.6743 12.8417C12.8827 12.6334 13.0827 12.4751 13.2743 12.3751C13.466 12.2584 13.6577 12.2001 13.866 12.2001C14.0243 12.2001 14.191 12.2334 14.3743 12.3084C14.5577 12.3834 14.7494 12.4917 14.9577 12.6334L17.716 14.5917C17.9327 14.7417 18.0827 14.9167 18.1743 15.1251C18.2577 15.3334 18.3077 15.5417 18.3077 15.7751Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.7961024633af6850e76fdef013278950.svg";
export { ForwardRef as ReactComponent };